export class ClassScheduleSession {
  id: string;
  description: string;
  startDateTime: string;
  endDateTime: string;
  formattedDate: string;
  formattedTime: string;
  active: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/class-schedule-session.ts